import React from "react";
import { createRoot } from "react-dom/client";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import { Landing } from "./pages/Landing";
import { Survey } from "./pages/Survey";
import { Waitlist } from "./pages/Waitlist";
import { I18nProvider } from "./i18n";
import { initPostHog } from "./lib/posthog";
import { CookieBanner } from "./ui/CookieBanner";
import "./index.css";

initPostHog();

function start() {
  const root = createRoot(document.getElementById("root")!);
  root.render(
    <React.StrictMode>
      <I18nProvider>
        <BrowserRouter>
          <Routes>
            <Route path="/" element={<Landing />} />
            <Route path="/survey" element={<Survey />} />
            <Route path="/waitlist" element={<Waitlist />} />
          </Routes>
          <CookieBanner />
        </BrowserRouter>
      </I18nProvider>
    </React.StrictMode>
  );
}

if (document.readyState === "loading") {
  document.addEventListener("DOMContentLoaded", start);
} else {
  start();
}
